import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { OrderDetailsNotesStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsNotes";
import { orderHistorySearchTagsStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchTags";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface OrderDetailsDirectShipmentStyles {
    directShipmentText?: TypographyProps;
    wrapper?: InjectableCss;
}

export const directShipmentStyles: OrderDetailsDirectShipmentStyles = {
    wrapper: {
        css: css`
            color: #004085;
            background-color: #cce5ff;
            border-color: #b8daff;
            padding: 20px;
            margin-top: 20px;
            margin-bottom: 20px;
            display: inline-block;
        `,
    },
    directShipmentText: {
        css: css``,
    },
};

const OrderDetailsDirectShipment = () => {
    const { value: order } = React.useContext(OrderStateContext);

    if (!order || !order.properties) {
        return null;
    }

    if (!("directshipment" in order.properties && order.properties["directshipment"] === "yes")) {
        return null;
    }

    return (
        <StyledWrapper {...directShipmentStyles.wrapper}>
            <Typography {...directShipmentStyles.directShipmentText}>{siteMessage("DirectShipmentMessage")}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsDirectShipment,
    definition: {
        displayName: "Order Details Direct Shipment",
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
